import React from "react";
import { SvgIcon } from "@mui/material";
import styles from "../../icons/iconStyles";

const TickIcon = ({ color }: any) => {
  return (
    <SvgIcon style={styles.icon}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5 11.6L7.93333 15L15 5"
          stroke={color || "#3EA293"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default TickIcon;
